/**
 * web/src/main.tsx —— 顶层入口（**main 在波0 预置**；W/S 不改本文件）。
 * 唯一实装通道＝WS（见 ../CONTRACT.md §1）；一切网络访问只经 ./transport。
 */
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tokens/xg-tokens.css";

const el = document.getElementById("app-root");
if (!el) throw new Error("缺少 #app-root 挂载点");

createRoot(el).render(
  React.createElement(React.StrictMode, null, React.createElement(App)),
);
